import axios from 'axios';

export const fetchTags = async () => {
    try {
        const { data } = await axios.get('/app/contactGroup/allTags?limit=1000&offset=0');

        return data;
    } catch (e) {
        throw new Error('Could not fetch tags');
    }
};

export const fetchTagCategories = async () => {
    try {
        const { data } = await axios.get('/app/contactGroup/allTagCategories');

        return data;
    } catch (e) {
        throw new Error('Could not fetch tag categories');
    }
};

export const createTag = async (tagData) => {
    const tag = {
        tagName: tagData.name.replace(/,/g, ''),
        tagCategory: tagData.category,
        tagDescription: tagData.description,
    };

    try {
        const { data } = await axios.post('/app/contactGroup/tag', tag);

        return data;
    } catch (e) {
        throw new Error('Could not create tag');
    }
};

export const createTagCategory = async (tagCategoryData) => {
    const category = {
        categoryName: tagCategoryData.name,
        categoryDescription: tagCategoryData.description,
    };

    try {
        const { data } = await axios.post('/app/contactGroup/tagCategory', category);

        return data;
    } catch (e) {
        throw new Error('Could not create tag category');
    }
};
